import React from 'react'
import { t } from 'translation'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'
import { Link } from 'react-router-dom'

const INFO_LIST = [
  'INFO_ACCESS_TO_SESSION',
  'INFO_APPLICATION_WEB_MOBILE_TABLET',
  'INFO_CLINICALLY_PROVED',
  'INFO_ORIGINAL_MUSIC',
]

const SubscriptionPatientStepOne = ({
  currency,
  freeDays,
  price,
  setSubscriptionStep,
}) => {
  return (
    <div className="auth_block">
      <h1 className="section_title v4_mod color_mod offset_v4_mod">
        {t('signup.FAST_RELIEF')}
      </h1>
      <ul className="auth_block_info_list offset_mod decor_mod">
        {INFO_LIST.map((item) => (
          <li key={item} className="auth_block_info_list_item">
            {t(`signup.${item}`)}
          </li>
        ))}
      </ul>
      <div className={`auth_block_info ${Number(price) === 0 ? 'zero_price_mod' : ''}`}>
        <div
          className={`auth_block_info_heading ${
            Number(price) === 0 ? 'zero_price_mod' : ''
          }`}
        >
          {freeDays && Number(price) > 0 ? (
            <div className="auth_block_info_title">
              <b>{t('signup.MONTHLY')}</b> - {freeDays} {t('signup.FIRST_DAYS_FREE')}
            </div>
          ) : null}
          <div className="auth_block_info_price">
            {currency === 'USD' ? '$' : null}
            {price}
            {currency === 'EUR' ? '€' : null} {t('subscription.PER_MONTH')}
          </div>
        </div>
        {freeDays > 0 && Number(price) > 0 && (
          <div className="auth_block_note limit_mod">
            {freeDays
              ? t('signup.FREE_DAYS_AUTOMATIC_RENEWAL_DESCR')
              : t('signup.AUTOMATIC_RENEWAL_DESCR')}
          </div>
        )}
      </div>
      <div className="btn_wrap center_lvl_mod">
        <LoadingButton
          onClick={() => setSubscriptionStep('four')}
          className="btn_base_v1 offset_mod"
          type="submit"
        >
          {t('signup.CONTINUE')}
        </LoadingButton>
      </div>
    </div>
  )
}

export default SubscriptionPatientStepOne
